export const getStations = (state) => state.changeNode.stations;
